module.exports = __webpack_public_path__ + "static/img/solution-3.43f5648.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/solution-3.png
// module id = DwD9
// module chunks = 10